import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const LINKS = [
  { name: "Home", href: "/" },
  { name: "Books & Workbooks", href: "/books" },
  { name: "Free Resources", href: "/free-resources" },
  { name: "About", href: "/about" },
  { name: "Speaking", href: "/speaking" },
  { name: "Group copies", href: "/group-copies" },
  { name: "Ask Derrick", href: "/ask" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const linkCls = (href) =>
    `text-sm whitespace-nowrap transition-colors duration-200 ${
      pathname === href
        ? "text-navy font-semibold"
        : "text-stone2 hover:text-navy font-medium"
    }`;

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-ivory/90 backdrop-blur-md border-b border-line">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between">
        <Link to="/" data-testid="nav-logo-link" className="shrink-0 pr-3 sm:pr-5">
          <Logo tagline={false} />
        </Link>

        <nav className="hidden xl:flex items-center gap-5" aria-label="Main">
          {LINKS.map((l) => (
            <Link
              key={l.href}
              to={l.href}
              data-testid={`nav-link-${l.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={linkCls(l.href)}
            >
              {l.name}
            </Link>
          ))}
          <Link
            to="/booking"
            data-testid="nav-cta-booking"
            className="bg-navy text-ivory hover:bg-navy-light transition-colors duration-200 px-4 py-2.5 rounded-full text-sm font-medium whitespace-nowrap"
          >
            Invite Chaplain Derrick
          </Link>
        </nav>

        <button
          className="xl:hidden p-2 -mr-2 text-navy"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden border-t border-line bg-ivory px-5 pb-6 pt-2">
          <nav className="flex flex-col" aria-label="Mobile">
            {LINKS.map((l) => (
              <Link
                key={l.href}
                to={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`py-3.5 border-b border-line/70 text-base ${
                  pathname === l.href ? "text-navy font-semibold" : "text-stone2"
                }`}
              >
                {l.name}
              </Link>
            ))}
            <Link
              to="/booking"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-booking"
              className="mt-5 bg-navy text-ivory text-center px-5 py-3.5 rounded-full text-sm font-medium"
            >
              Invite Chaplain Derrick
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
